import { render, staticRenderFns } from "./MergeOrderDrawer.vue?vue&type=template&id=896b3282&scoped=true"
import script from "./MergeOrderDrawer.vue?vue&type=script&lang=js"
export * from "./MergeOrderDrawer.vue?vue&type=script&lang=js"
import style0 from "./MergeOrderDrawer.vue?vue&type=style&index=0&id=896b3282&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896b3282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896b3282')) {
      api.createRecord('896b3282', component.options)
    } else {
      api.reload('896b3282', component.options)
    }
    module.hot.accept("./MergeOrderDrawer.vue?vue&type=template&id=896b3282&scoped=true", function () {
      api.rerender('896b3282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/SplitAndMerge/MergeOrderDrawer.vue"
export default component.exports